import { useLayoutEffect } from 'react';
import type { DetrixSession } from '../types';
import { usePlaybackStore } from '../store/usePlaybackStore';
import { sessionTimeBounds } from '../core/session';

/**
 * Owns playback bounds initialization for the current session.
 * Must run from a parent of {@link SessionTimeline} so bounds exist before the timeline reads store state.
 */
export function useSessionPlayback(session: DetrixSession): void {
  const initPlaybackSession = usePlaybackStore((s) => s.initPlaybackSession);
  const { min, max } = sessionTimeBounds(session);

  useLayoutEffect(() => {
    initPlaybackSession(session.sessionId, min, max);
  }, [session.sessionId, min, max, initPlaybackSession]);
}
